<template>
  <div class="report-create-wrap">
    <el-row>
      <el-col :span="20" :offset="4">
        <el-form
          ref="addForm"
          label-position="right"
          :model="addForm"
          :rules="rules"
          label-width="180px"
          class="report-create-form"
        >
          <el-form-item label="报备类型：">
            <span class="fs-13">延迟发货</span>
          </el-form-item>

          <el-form-item label="延迟发货原因：" prop="report_reason">
            <el-select
              v-model="addForm.report_reason"
              clearable
              placeholder="请选择"
              style="width: 400px;"
            >
              <el-option
                v-for="item in reasonList"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：" prop="report_detailed_reason">
            <el-input
              type="textarea"
              v-model="addForm.report_detailed_reason"
              style="width: 400px;"
              maxlength="50"
              clearable
              placeholder="请输入报备原因，有助于审核通过，最多不超过50个字"
            />
          </el-form-item>
          <el-form-item label="受影响订单：" prop="orderList">
            <effectOrderList
              :ids="report_ids"
              @showOrder="showOrder"
              @exportOrder="exportOrder"
              @resetOrderIds="resetOrderIds"
              :pageType="pageType"
            />
          </el-form-item>

          <el-form-item label="预计发货日：" prop="report_delay_day">
            <el-date-picker
              v-model="addForm.report_delay_day"
              type="date"
              style="width: 400px;"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
              :pickerOptions="pickerOptions"
            />
          </el-form-item>
          <div class="create-tips">
            <span>*</span>
            温馨提示：所选择的订单均需要在【预计发货日】之前发出，不包含【预计发货日】当天，若商家未按照报备时间履约，则属于二次违约，相关责任需由商家自行承担。
          </div>
          <el-form-item label="上传凭证：" prop="filesList">
            <el-upload
              class="img-upload"
              action=""
              ref="uploadImg"
              :headers="headers"
              list-type="picture-card"
              :auto-upload="true"
              :limit="3"
              :before-upload="beforeAvatarUpload"
              :on-exceed="exce"
              :http-request="httpRequest"
              :on-remove="handleRemove"
              :file-list="fileList"
              :disabled="pageType == 'check'"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <span
              >仅支持上传jpg、png格式图片，图片大小不得超过5M，最多上传3张。</span
            >
            <div style="color: red;" v-if="resetNum != undefined">
              *今天最多还能上传{{ resetNum }}张图片！
            </div>
          </el-form-item>
          <div
            class="flex-row-center-center action-btns"
            v-if="pageType == 'create' || pageType == 'edit'"
          >
            <el-button
              type="primary"
              class="default-btn"
              @click="handleSubmit(0)"
            >
              保存草稿，返回上一页
            </el-button>
            <el-button
              type="primary"
              @click="onSubmit('addForm')"
              style="margin:0 40px"
            >
              提交
            </el-button>
            <el-button type="primary" @click="resetForm" class="default-btn">
              不保存，取消
            </el-button>
          </div>
          <div class="action-btns" style="text-align: center;" v-else>
            <el-button type="primary" @click="resetForm" class="default-btn">
              返回上一页
            </el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <!-- <div class="create-tips">
      <span>*</span>
      温馨提醒：若商家未按照报备时间履约，则属于二次违约，相关责任需由商家自行承担。
    </div> -->
    <effectOrderDialog
      ref="childDialog"
      @setOrderIds="setOrderIds"
      :selectAllIds="this.report_ids"
    />
  </div>
</template>

<script>
import {
  getDelayEnum,
  uploadImg,
  postReportApply,
  getReportDetail
} from "@/models/orderReportModel";
import effectOrderDialog from "./components/effectDialog";
import effectOrderList from "./components/effectOrderList";
import moment from "moment";
export default {
  components: { effectOrderDialog, effectOrderList },
  data() {
    return {
      loading: false,
      visible: false, //订单弹框
      selectionRows: [],
      tableData: [{ reportId: 1 }], // 表格数据
      queryInfo: {
        page: 1,
        page_size: 10,
        current: 1, // 当前页
        total: 0 //总数
      }, // 分页配置数据
      addForm: {
        report_reason: undefined,
        report_detailed_reason: "",
        orderList: [],
        report_delay_day: ""
      },
      report_ids: "",
      reasonList: [],
      rules: {
        report_reason: [
          { required: true, message: "请选择延迟发货原因!", trigger: "change" }
        ],
        report_detailed_reason: [
          {
            required: true,
            message: "请输入报备原因!"
          }
        ],
        orderList: [
          { type: "array", required: true, message: "请选择受影响订单!" }
        ],
        report_delay_day: [
          {
            required: true,
            message: "请选择日期!"
          }
        ]
      },
      imgArr: [],
      fileList: [],
      headers: {
        Authorization: localStorage.getItem("token")
      },
      pageType: "create", //当前页面操作类型：check-查看，edit-编辑，create-创建
      detailInfo: {},
      resetNum: undefined,
      pickerOptions: {
        disabledDate(current) {
          return current && current < moment().subtract(1, "days");
        }
      }
    };
  },
  created() {
    this.getEnum();
    // console.log("this.route:", this.$route);
    const type = this.$route.params.type;
    this.pageType = type;
    if (type == "check" || type == "edit") {
      this.getDetailInfo(this.$route.params.id);
    }
  },
  methods: {
    // 枚举
    getEnum() {
      getDelayEnum()
        .then(res => {
          let arr = [];
          if (res) {
            for (const key in res) {
              if (Object.hasOwnProperty.call(res, key)) {
                arr.push({ label: res[key], value: key });
              }
            }
            this.reasonList = arr;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 详情数据
    getDetailInfo(id) {
      getReportDetail({ id })
        .then(res => {
          this.addForm = {
            report_reason: `${res.report_reason}`,
            report_detailed_reason: res.report_detailed_reason,
            report_delay_day: res.delay_day,
            orderList: res.order_ids || []
          };
          this.report_ids = Array.isArray(res.order_ids)
            ? res.order_ids.join(",")
            : "";
          if (res.report_imgs && res.report_imgs != "null") {
            // let imgs = res.report_imgs;
            let imgArr = [];
            let fileList = [];
            res.report_imgs.map((item, index) => {
              imgArr.push({ fileName: `img${index + 1}`, path: item });
              fileList.push({
                name: `img${index + 1}`,
                url: `${res.report_imgs_host}${item}`
              });
            });
            this.imgArr = imgArr;
            this.fileList = fileList;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    //提交
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.onConfirm();
        } else {
          this.$message.warning("请根据提示完善信息！");
          return false;
        }
      });
    },
    // 二次确认弹框
    onConfirm() {
      this.$confirm("确定要提交申请吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false
      })
        .then(() => {
          this.handleSubmit(1);
        })
        .catch(() => {});
    },
    // 提交、保存
    handleSubmit(is_submit) {
      // console.log("this.form:", this.addForm);
      // return false;
      const {
        report_reason,
        report_detailed_reason,
        report_delay_day
      } = this.addForm;
      let report_images = "";

      this.imgArr.map((item, index) => {
        report_images += index == 0 ? item.path : `,${item.path}`;
      });
      // console.log("params:", params);
      const params = {
        is_submit,
        report_type: 1,
        report_reason,
        report_detailed_reason,
        report_delay_day,
        report_ids: this.report_ids,
        report_images
      };
      if (this.$route.params.id) {
        params.id = this.$route.params.id;
      }
      postReportApply(params)
        .then(res => {
          this.$message({
            type: "success",
            message: is_submit == 1 ? "提交成功！" : "保存成功！"
          });
          this.$router.go(-1);
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },

    //返回上一页
    resetForm() {
      this.$router.go(-1);
    },
    // 移除图片
    handleRemove(file) {
      const newArr = this.imgArr.filter(item => item.fileName != file.name);
      this.imgArr = newArr;
      // let arr = [];
      // newArr.map((item, index) => {
      //   arr.push({
      //     name: `img${index + 1}`,
      //     url: `${item.host}${item.path}`
      //   });
      // });
      // this.fileList = arr;
    },
    // 打开订单弹框
    showOrder() {
      this.$refs.childDialog.showDialog();
    },
    //上传时，判断文件的类型及大小是否符合规则
    beforeAvatarUpload(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      let flag = true;
      if (!isJPG) {
        this.$message.warning("上传图片只能是 JPG/PNG/GIF 格式!");
        return isJPG;
      }
      if (!isLt5M) {
        this.$message.warning("上传图片大小不能超过 5MB!");
        return isLt5M;
      }
      if (this.resetNum == 0) {
        this.$message.warning("今日上传图片数量已达上限!");
        flag = false;
      }
      return isJPG && isLt5M && flag;
    },
    // 文件上传
    httpRequest(data) {
      if (data && data.file) {
        const fd = new FormData();
        fd.append("shop_id", localStorage.getItem("shop_id"));
        fd.append("file", data.file);
        uploadImg(fd)
          .then(res => {
            // console.log("addImg-res:", res);
            const { current_count, max_count, file_name, host } = res;
            this.imgArr.push({
              fileName: data.file.name,
              path: file_name,
              host
            });
            this.resetNum = max_count - current_count;
            // this.fileList.push({
            //   name: `img${current_count}`,
            //   url: `${host}${file_name}`
            // });
          })
          .catch(err => {
            this.$message.error(err.message);
            console.log("upload--img:", this.$refs.uploadImg.uploadFiles);
            this.$refs.uploadImg.uploadFiles = this.$refs.uploadImg.uploadFiles.filter(
              (e, i) => {
                if (e.status != "ready") return e;
              }
            );
          });
      }
    },
    exce() {
      this.$message.warning("最多上传3张图片");
    },
    // 添加受影响订单
    setOrderIds(ids) {
      const oldData =
        this.report_ids.length > 0 ? this.report_ids.split(",") : [];
      const newData = oldData.concat(ids);
      this.addForm.orderList = newData;
      this.report_ids = newData.join(",");
    },
    // 移除订单
    resetOrderIds(ids) {
      this.addForm.orderList = ids;
      this.report_ids = ids.join(",");
    },
    // 导入订单弹框(需要判断去重id)
    exportOrder(ids) {
      const oldData =
        this.report_ids.length > 0 ? this.report_ids.split(",") : [];
      const newData = oldData.concat(ids);
      const uniqueData = Array.from(new Set(newData));
      this.addForm.orderList = uniqueData;
      this.report_ids = uniqueData.join(",");
    }
  }
};
</script>
<style lang="scss">
.report-create-wrap {
  .m-b-8 {
    margin-bottom: 8px;
  }
  .c-red {
    color: #ff4d4f;
  }
  .opt-btn {
    cursor: pointer;
    color: #ff6224;
  }
  .default-btn {
    background: #fff;
    color: #ff6224;
    border-color: #ccc;
    color: #666;
  }
  .select-btn {
    display: inline-block;
    border: 1px solid #ff6224;
    padding: 0px 8px;
    border-radius: 4px;
    line-height: 24px;
    color: #ff6224;
    margin-right: 8px;
    font-size: 13px;
    cursor: pointer;
  }
  .report-create-form .el-form-item {
    margin-bottom: 18px;

    .c-red {
      color: #ff4d4f;
    }
  }
  .el-form-item__label {
    text-align: right !important;
    font-size: 14px;
  }
  .action-btns {
    width: 70%;
    margin-top: 80px;
  }
  .create-tips {
    font-size: 12px;
    color: #777;
    margin-left: 72px;
    margin-top: -10px;
    margin-bottom: 16px;
    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
.report-order-dialog {
  .el-form-item__label {
    text-align: right !important;
    font-size: 14px;
  }
  .checked-tips {
    position: absolute;
    top: 0;
    left: 64px;
  }
}
/deep/.el-table tr {
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/orderReport/reportCenter/create.vue